export default __webpack_public_path__ + "static/media/index.js.e5ec878c.flow";